module.exports = __webpack_public_path__ + "img/9788992449694.9c76ef40.jpg";